const SAUDI_COUNTRY_ALIASES = ['sa', 'ksa', 'saudi arabia', 'saudi']
const UAE_COUNTRY_ALIASES = ['ae', 'uae', 'united arab emirates']

const isSaudiCountry = (country: string | null | undefined): boolean => {
  if (!country) return false
  return SAUDI_COUNTRY_ALIASES.includes(country.toLowerCase())
}

// Semantic aliases so call sites read as origin/destination intent while
// sharing a single source of truth for the accepted country strings.
export const isDestinationSaudi = isSaudiCountry
export const isOriginSaudi = isSaudiCountry

// A missing country counts as the UAE: it is what every address on this page
// was before exports could be edited, so an absent value keeps the old
// (UAE-only) form rather than silently dropping the emirate picker (sc-32609).
export const isUAECountry = (country: string | null | undefined): boolean =>
  !country || UAE_COUNTRY_ALIASES.includes(country.trim().toLowerCase())

export const isSaudiDomestic = (
  originCountry: string | null | undefined,
  destinationCountry: string | null | undefined
): boolean =>
  isOriginSaudi(originCountry) && isDestinationSaudi(destinationCountry)

export const getCurrency = (country: string | null | undefined): string =>
  isOriginSaudi(country) ? 'SAR' : 'AED'
